export default {
  colors: {
    default: '#5C70A4', //'#344675'
    primary: '#01B0E0', //'#42b883'
    info: '#BA54F5', //'#1d8cf8'
    danger: '#F84E54', //'#fd5d93'
    orange: '#ff8a76', // '#ff8a76'
    warning: '#ff8d72', // '#ff8a76'
    success: '#00BF9A', // '#ff8a76'
    teal: '#00d6b4', //'#00d6b4'
    primaryGradient: [
      'rgba(76, 211, 150, 0.1)',
      'rgba(53, 183, 125, 0)',
      'rgba(119,52,169,0)'
    ],
    purpleGradient: ['rgba(253,93,147,0.8)', 'rgba(253,93,147,0)'],
    viewsGradient: ['rgba(1,176,224,1)', 'rgba(158,119,243,1)'],
    successGradient: ['rgba(0,191,154,1)', 'rgba(158,119,243,0.5)'],
    // hehe:'linear-gradient(#e66465, #9198e5)',
  },
  // ChartColors: {

  // }
};
